import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useAuthStore } from './store/authStore';

// Pages
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Tasks from './pages/Tasks';
import Campaigns from './pages/Campaigns';
import Rewards from './pages/Rewards';
import Earnings from './pages/Earnings';
import Profile from './pages/Profile';
import Social from './pages/Social';
import Posts from './pages/Posts';
import Messages from './pages/Messages';
import TrackPost from './pages/TrackPost';
import ReferralLinks from './pages/ReferralLinks';
import Admin from './pages/Admin';
import FacebookCallback from './pages/FacebookCallback';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Layout from './components/Layout';
import ErrorBoundary from './components/ErrorBoundary';

const queryClient = new QueryClient();

function PrivateRoute({ children }) {
  const token = useAuthStore(state => state.token);
  return token ? children : <Navigate to="/login" />;
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ErrorBoundary>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/auth/callback" element={<FacebookCallback />} />
          
          <Route path="/" element={
            <PrivateRoute>
              <Layout />
            </PrivateRoute>
          }>
            <Route index element={<Dashboard />} />
            <Route path="tasks" element={<Tasks />} />
            <Route path="campaigns" element={<Campaigns />} />
            <Route path="rewards" element={<Rewards />} />
            <Route path="earnings" element={<Earnings />} />
            <Route path="profile" element={<Profile />} />
            <Route path="social" element={<Social />} />
            <Route path="posts" element={<Posts />} />
            <Route path="messages" element={<Messages />} />
            <Route path="track-post" element={<TrackPost />} />
            <Route path="referral-links" element={<ReferralLinks />} />
            <Route path="admin" element={<Admin />} />
          </Route>
        </Routes>
      </Router>
      </ErrorBoundary>
    </QueryClientProvider>
  );
}

export default App;
